import * as tslib_1 from "tslib";
import { EventEmitter } from '@angular/core';
import { util } from '../classes/util';
import { environment } from '../environment';
import { ESRI } from '../esri-loader-util';
import { isQueryableMapCoreLayer, LogLevel } from '../types';
import { FilterService } from './filter.service';
import { GeocodeService } from './geocode.service';
import { GisToolsService } from './gis-tools.service';
import { LayerService } from './layer.service';
import { MapService } from './map.service';
import { SpatialQueryService } from './spatialQuery.service';
import { ToSqlStringService } from './to-sql-string.service';
import * as i0 from "@angular/core";
import * as i1 from "./layer.service";
import * as i2 from "./geocode.service";
import * as i3 from "./gis-tools.service";
import * as i4 from "./map.service";
import * as i5 from "./spatialQuery.service";
import * as i6 from "./filter.service";
import * as i7 from "./to-sql-string.service";
var AoiService = /** @class */ (function () {
    function AoiService(layerService, geocodeService, gisToolsService, mapService, spatialQueryService, filterService, LoggingService, toSqlStringService) {
        this.layerService = layerService;
        this.geocodeService = geocodeService;
        this.gisToolsService = gisToolsService;
        this.mapService = mapService;
        this.spatialQueryService = spatialQueryService;
        this.filterService = filterService;
        this.LoggingService = LoggingService;
        this.toSqlStringService = toSqlStringService;
        this.aoiQueryName = 'AOI';
        this.boundarySymbol = {
            color: [255, 255, 255, 0.1],
            style: 'none',
            outline: {
                color: [0, 0, 0],
                style: 'solid',
                width: 2
            }
        };
        this.openStreetViewEvent = new EventEmitter();
    }
    AoiService.prototype.loadColumnIdentifiers = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!!this.columnIdentifiers) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.gisToolsService.getAllColumnIdentifiers('name, id').then(function (result) {
                                _this.columnIdentifiers = result;
                            })];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    };
    AoiService.prototype.getSearchCriterias = function () {
        return this.searchCriterias;
    };
    AoiService.prototype.setSearchCriterias = function (searchCriterias) {
        this.searchCriterias = this.cloneDeep(searchCriterias);
    };
    AoiService.prototype.clearSearchCriterias = function () {
        this.searchCriterias = [];
    };
    AoiService.prototype.cloneDeep = function (arr) {
        var e_1, _a;
        if (!arr) {
            return arr;
        }
        var retVal = [];
        try {
            for (var arr_1 = tslib_1.__values(arr), arr_1_1 = arr_1.next(); !arr_1_1.done; arr_1_1 = arr_1.next()) {
                var val = arr_1_1.value;
                if (Array.isArray(val)) {
                    retVal.push(this.cloneDeep(val));
                }
                else if (typeof val === 'object') {
                    retVal.push(this.cloneDeepObj(val));
                }
                else {
                    retVal.push(val);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (arr_1_1 && !arr_1_1.done && (_a = arr_1.return)) _a.call(arr_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return retVal;
    };
    AoiService.prototype.cloneDeepObj = function (obj) {
        var e_2, _a;
        if (!obj) {
            return obj;
        }
        var retVal = {};
        try {
            for (var _b = tslib_1.__values(Object.keys(obj)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                var val = obj[key];
                if (Array.isArray(val)) {
                    retVal[key] = this.cloneDeep(val);
                }
                else if (typeof val === 'object') {
                    retVal[key] = this.cloneDeepObj(val);
                }
                else {
                    retVal[key] = val;
                }
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_2) throw e_2.error; }
        }
        return retVal;
    };
    AoiService.prototype.showAOIByAddress = function (address, magicKey, isAoi) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                return [2 /*return*/, new Promise(function (resolve) {
                        _this.geocodeService.find(address, magicKey).subscribe(function (result) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var Graphic, res, point, pointGraphic;
                            return tslib_1.__generator(this, function (_a) {
                                switch (_a.label) {
                                    case 0:
                                        if (!(result.candidates.length > 0)) return [3 /*break*/, 3];
                                        return [4 /*yield*/, ESRI.Graphic];
                                    case 1:
                                        Graphic = _a.sent();
                                        res = result.candidates[0];
                                        point = {
                                            type: 'point',
                                            x: res.location.x,
                                            y: res.location.y,
                                            spatialReference: result.spatialReference
                                        };
                                        pointGraphic = new Graphic({
                                            geometry: point,
                                            symbol: {
                                                type: 'simple-marker',
                                                style: 'circle',
                                                color: 'yellow',
                                                size: '16px'
                                            }
                                        });
                                        return [4 /*yield*/, this.addGraphicAndZoomToIt(pointGraphic, "AOI - " + address, isAoi)];
                                    case 2:
                                        _a.sent();
                                        _a.label = 3;
                                    case 3:
                                        resolve();
                                        return [2 /*return*/];
                                }
                            });
                        }); });
                    })];
            });
        });
    };
    AoiService.prototype.showAOIByLatLong = function (latitude, longitude, isAoi) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var Graphic, pointGraphic;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ESRI.Graphic];
                    case 1:
                        Graphic = _a.sent();
                        pointGraphic = new Graphic({
                            geometry: {
                                type: 'point',
                                latitude: latitude,
                                longitude: longitude
                            },
                            symbol: {
                                type: 'simple-marker',
                                style: 'circle',
                                color: 'yellow',
                                size: '16px'
                            }
                        });
                        return [4 /*yield*/, this.addGraphicAndZoomToIt(pointGraphic, 'AOI - Lat/Lon Point', isAoi)];
                    case 2:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AoiService.prototype.addGraphicAndZoomToIt = function (pointGraphic, title, isAoi) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!this.graphicsLayer || !this.graphicsLayer.parent)) return [3 /*break*/, 2];
                        _a = this;
                        return [4 /*yield*/, this.layerService.addGraphicsLayer({ title: title }, { isAOI: isAoi })];
                    case 1:
                        _a.graphicsLayer = _b.sent();
                        _b.label = 2;
                    case 2:
                        this.graphicsLayer.add(pointGraphic);
                        this.layerService.zoomToGraphic(pointGraphic);
                        return [2 /*return*/];
                }
            });
        });
    };
    AoiService.prototype.processSearchCriterias = function (isAoi) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, result, countySearchCriteria, newCountySearchCriteria, districtSearchCriteria, newDistrictSearchCriteria, titles;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.searchCriterias && this.searchCriterias.length > 0)) return [3 /*break*/, 7];
                        _a = this.searchCriterias[0].type;
                        switch (_a) {
                            case 'state': return [3 /*break*/, 1];
                            case 'address': return [3 /*break*/, 2];
                            case 'latLong': return [3 /*break*/, 4];
                        }
                        return [3 /*break*/, 6];
                    case 1: return [2 /*return*/];
                    case 2: return [4 /*yield*/, this.showAOIByAddress(this.searchCriterias[0].address, this.searchCriterias[0].magicKey, isAoi)];
                    case 3:
                        _b.sent();
                        return [2 /*return*/];
                    case 4: return [4 /*yield*/, this.showAOIByLatLong(this.searchCriterias[0].latitude, this.searchCriterias[0].longitude, isAoi)];
                    case 5:
                        _b.sent();
                        return [2 /*return*/];
                    case 6: return [3 /*break*/, 7];
                    case 7:
                        result = {
                            title: null,
                            query: { operator: 'OR' }
                        };
                        if (this.searchCriterias && this.searchCriterias.length > 0) {
                            countySearchCriteria = this.searchCriterias.filter(function (sc) { return sc.type === 'county'; });
                            if (countySearchCriteria.length > 1) {
                                this.searchCriterias = util.removeFromArray(this.searchCriterias, countySearchCriteria);
                                newCountySearchCriteria = tslib_1.__assign({}, countySearchCriteria[0]);
                                newCountySearchCriteria.countyCode = undefined;
                                newCountySearchCriteria.countyCodes = countySearchCriteria.map(function (csc) { return csc.countyCode; });
                                this.searchCriterias.push(newCountySearchCriteria);
                            }
                            districtSearchCriteria = this.searchCriterias.filter(function (sc) { return sc.type === 'district'; });
                            if (districtSearchCriteria.length > 1) {
                                this.searchCriterias = util.removeFromArray(this.searchCriterias, districtSearchCriteria);
                                newDistrictSearchCriteria = tslib_1.__assign({}, districtSearchCriteria[0]);
                                newDistrictSearchCriteria.countyCode = undefined;
                                newDistrictSearchCriteria.countyCodes = districtSearchCriteria.map(function (csc) { return csc.countyCode; });
                                this.searchCriterias.push(newDistrictSearchCriteria);
                            }
                        }
                        result.query.subqueries = this.searchCriterias.map(function (searchCriteria) {
                            switch (searchCriteria.type) {
                                case 'district':
                                    return _this.districtsSetup(result, searchCriteria);
                                case 'county':
                                    return _this.countiesSetup(result, searchCriteria);
                                case 'zipCode':
                                    result.layerId = environment.layers.find(function (l) { return l.name === 'zipCode'; }).id;
                                    result.title = "ZipCode: " + searchCriteria.zip;
                                    return {
                                        field: 'zip',
                                        operator: '=',
                                        value: searchCriteria.zip
                                    };
                                case 'municipality':
                                    result.layerId = environment.layers.find(function (l) { return l.name === 'municipality'; }).id;
                                    result.title = "County: " + searchCriteria.countyCode + " Municipality: " + searchCriteria.municipalityCode;
                                    return {
                                        operator: 'AND',
                                        subqueries: [
                                            { field: 'county', operator: '=', value: searchCriteria.countyCode },
                                            { field: 'municipal_code', operator: '=', value: searchCriteria.municipalityCode }
                                        ]
                                    };
                                case 'schoolDistrict':
                                    result.layerId = environment.layers.find(function (l) { return l.name === 'schoolDistrict'; }).id;
                                    result.title = "County: " + searchCriteria.countyCode + " schoolDistrict: " + searchCriteria.schoolDistrictName;
                                    return {
                                        operator: 'AND',
                                        subqueries: [
                                            { field: 'PA_CTY_CODE', operator: '=', value: searchCriteria.countyCode },
                                            { field: 'SCHOOL_DISTRICT', operator: '=', value: searchCriteria.schoolDistrictName }
                                        ]
                                    };
                                case 'planningPartner':
                                    result.layerId = environment.layers.find(function (l) { return l.name === 'planningPartner'; }).id;
                                    result.title = "Planning Partner: " + searchCriteria.planningPartnerShortName;
                                    return {
                                        field: 'PLN_PRTNR_SHRTNM',
                                        operator: '=',
                                        value: searchCriteria.planningPartnerShortName
                                    };
                                case 'houseDistrict':
                                    result.layerId = environment.layers.find(function (l) { return l.name === 'houseDistrict'; }).id;
                                    result.title = "House District: " + searchCriteria.houseDistrictNumber;
                                    return {
                                        field: 'LEG_DISTRICT_NO',
                                        operator: '=',
                                        value: searchCriteria.houseDistrictNumber.toString()
                                    };
                                case 'senateDistrict':
                                    result.layerId = environment.layers.find(function (l) { return l.name === 'senateDistrict'; }).id;
                                    result.title = "Senate District: " + searchCriteria.senateDistrictNumber;
                                    return {
                                        field: 'LEG_DISTRICT_NO',
                                        operator: '=',
                                        value: searchCriteria.senateDistrictNumber.toString()
                                    };
                                case 'congressionalDistrict':
                                    result.layerId = environment.layers.find(function (l) { return l.name === 'congressDistrict'; }).id;
                                    result.title = "Congressional District: " + searchCriteria.congressionalDistrictNumber;
                                    return {
                                        field: 'LEG_DISTRICT_NO',
                                        operator: '=',
                                        value: searchCriteria.congressionalDistrictNumber.toString()
                                    };
                                case 'route':
                                    result.layerId = environment.layers.find(function (l) { return l.name === 'rmsseg'; }).id;
                                    var components = [searchCriteria.countyCode, searchCriteria.stateRouteNumber, searchCriteria.segBgn, searchCriteria.segEnd, searchCriteria.offset];
                                    components = components.filter(function (x) { return x; });
                                    if (components.length > 1) {
                                        result.title = components.join('|');
                                    }
                                    var subqueries = _this.constructRouteSubqueries(searchCriteria);
                                    return {
                                        operator: 'AND',
                                        subqueries: subqueries
                                    };
                                case 'assetId':
                                    if (searchCriteria) {
                                        result.layerId = searchCriteria.layerId;
                                        if (searchCriteria.data && searchCriteria.columnName) {
                                            var operator = '=';
                                            if (searchCriteria && searchCriteria.data.split(',').length > 1) {
                                                operator = 'IN';
                                            }
                                            return {
                                                field: searchCriteria.columnName,
                                                operator: operator,
                                                value: searchCriteria.data
                                            };
                                        }
                                        else if (searchCriteria.query) {
                                            return searchCriteria.query;
                                        }
                                    }
                                    else {
                                        return null;
                                    }
                                    break;
                                case 'intersection':
                                    result.layerId = environment.layers.find(function (l) { return l.name === 'intersection'; }).id;
                                    return searchCriteria.query;
                                case 'tsmo':
                                    result.layerId = environment.layers.find(function (l) { return l.name === 'district'; }).id;
                                    result.title = "TSMO District" + (searchCriteria.districtNumbers.length > 1 ? 's' : '') + ": " + searchCriteria.districtNumbers.join(',');
                                    return {
                                        field: 'DISTRICT_NUMBER',
                                        operator: 'IN',
                                        value: searchCriteria.districtNumbers.join(',')
                                    };
                                default:
                                    break;
                            }
                        });
                        if (result.query.subqueries) {
                            result.query.subqueries = result.query.subqueries.filter(function (x) { return x !== undefined; });
                        }
                        if (!result.title) {
                            titles = this.searchCriterias.map(function (s) { return s.title; }).filter(function (x) { return x; });
                            if (titles.length) {
                                result.title = 'AOI - ' + titles.join(', ');
                            }
                        }
                        return [2 /*return*/, result];
                }
            });
        });
    };
    AoiService.prototype.districtsSetup = function (result, searchCriteria) {
        result.layerId = environment.layers.find(function (l) { return l.name === 'district'; }).id;
        var districts = searchCriteria.districtNumbers || [searchCriteria.districtNumber];
        result.title = "District Number" + (districts.length > 1 ? 's' : '') + ": " + districts.join(', ');
        return {
            field: 'DISTRICT_NUMBER',
            operator: districts.length > 1 ? 'IN' : '=',
            value: districts.join(',')
        };
    };
    AoiService.prototype.countiesSetup = function (result, searchCriteria) {
        result.layerId = environment.layers.find(function (l) { return l.name === 'county'; }).id;
        var counties = searchCriteria.countyCodes || [searchCriteria.countyCode];
        result.title = "Count" + (counties.length > 1 ? 'ies' : 'y') + ": " + counties.join(', ');
        return {
            field: 'COUNTY_NUMBER',
            operator: counties.length > 1 ? 'IN' : '=',
            value: counties.join(',')
        };
    };
    AoiService.prototype.constructDistrictSubquery = function (searchCriteria, districtColumn) {
        return {
            field: districtColumn.name,
            operator: searchCriteria.districtNumbers ? 'IN' : '=',
            value: searchCriteria.districtNumber || searchCriteria.districtNumbers.join(',')
        };
    };
    AoiService.prototype.constructCountySubquery = function (searchCriteria, countyColumn) {
        return {
            field: countyColumn.name,
            operator: searchCriteria.countyCodes ? 'IN' : '=',
            value: searchCriteria.countyCode || searchCriteria.countyCodes.join(',')
        };
    };
    AoiService.prototype.constructRouteSubqueries = function (searchCriteria) {
        var subqueries = [];
        if (searchCriteria.countyCode) {
            subqueries = subqueries.concat([{ field: 'CTY_CODE', operator: '=', value: searchCriteria.countyCode }]);
        }
        if (searchCriteria.stateRouteNumber) {
            subqueries = subqueries.concat([{ field: 'ST_RT_NO', operator: '=', value: searchCriteria.stateRouteNumber }]);
        }
        if (searchCriteria.segBgn && searchCriteria.segEnd) {
            subqueries = subqueries.concat([
                { field: 'SEG_NO', operator: '>=', value: searchCriteria.segBgn },
                { field: 'SEG_NO', operator: '<=', value: searchCriteria.segEnd }
            ]);
        }
        else if (searchCriteria.segBgn) {
            subqueries = subqueries.concat([{ field: 'SEG_NO', operator: '=', value: searchCriteria.segBgn }]);
        }
        return subqueries;
    };
    AoiService.prototype.getDistrictColumn = function (columns) {
        var _this = this;
        return columns.find(function (c) { return c.columnIdentifierId === _this.columnIdentifiers.find(function (i) { return i.name === 'districtNumber'; }).id; });
    };
    AoiService.prototype.getCountyColumn = function (columns) {
        var _this = this;
        return columns.find(function (c) { return c.columnIdentifierId === _this.columnIdentifiers.find(function (i) { return i.name === 'countyCode'; }).id; });
    };
    AoiService.prototype.generateFilterSubqueries = function (mapcoreProps, columns) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var subqueries;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!mapcoreProps.parentId || !this.searchCriterias) {
                            return [2 /*return*/, []];
                        }
                        if (this.searchCriterias && this.searchCriterias.length > 0 && this.searchCriterias[0].type === 'state') {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.loadColumnIdentifiers()];
                    case 1:
                        _a.sent();
                        if (!!columns) return [3 /*break*/, 3];
                        columns = mapcoreProps.columns;
                        if (!(!columns || columns.length === 0)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.gisToolsService.getColumns(mapcoreProps.parentId, 'name, columnIdentifierId')];
                    case 2:
                        columns = _a.sent();
                        _a.label = 3;
                    case 3: return [4 /*yield*/, Promise.all(this.searchCriterias.map(function (searchCriteria) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                            var _a, districtColumn, county, counties, countyColumn, planningPartnerColumnIdentifier_1, planningPartnerColumn, houseColumnIdentifier_1, houseColumn, senateColumnIdentifier_1, senateColumn, congressColumnIdentifier_1, congressColumn, countyQuery, districtIdentifier_1, district, ctyIdentifier_1, cty, counties;
                            var _this = this;
                            return tslib_1.__generator(this, function (_b) {
                                switch (_b.label) {
                                    case 0:
                                        _a = searchCriteria.type;
                                        switch (_a) {
                                            case 'district': return [3 /*break*/, 1];
                                            case 'county': return [3 /*break*/, 4];
                                            case 'municipality': return [3 /*break*/, 5];
                                            case 'planningPartner': return [3 /*break*/, 6];
                                            case 'houseDistrict': return [3 /*break*/, 7];
                                            case 'senateDistrict': return [3 /*break*/, 8];
                                            case 'congressionalDistrict': return [3 /*break*/, 9];
                                            case 'route': return [3 /*break*/, 10];
                                            case 'intersection': return [3 /*break*/, 11];
                                            case 'tsmo': return [3 /*break*/, 12];
                                        }
                                        return [3 /*break*/, 15];
                                    case 1:
                                        districtColumn = this.getDistrictColumn(columns);
                                        if (districtColumn) {
                                            return [2 /*return*/, this.constructDistrictSubquery(searchCriteria, districtColumn)];
                                        }
                                        county = this.getCountyColumn(columns);
                                        if (!county) return [3 /*break*/, 3];
                                        return [4 /*yield*/, this.gisToolsService.getCountiesByDistricts([searchCriteria.districtNumber])];
                                    case 2:
                                        counties = _b.sent();
                                        return [2 /*return*/, {
                                                field: county.name,
                                                operator: 'IN',
                                                value: counties.map(function (c) { return c.countyCode; }).toString()
                                            }];
                                    case 3: return [3 /*break*/, 16];
                                    case 4:
                                        countyColumn = this.getCountyColumn(columns);
                                        if (countyColumn) {
                                            return [2 /*return*/, this.constructCountySubquery(searchCriteria, countyColumn)];
                                        }
                                        return [3 /*break*/, 16];
                                    case 5: return [2 /*return*/, this.generateMunicipalityFilterSubqueries(columns, searchCriteria)];
                                    case 6:
                                        planningPartnerColumnIdentifier_1 = this.columnIdentifiers.find(function (i) { return i.name === 'planningPartnerShortName'; }).id;
                                        planningPartnerColumn = columns.find(function (c) { return c.columnIdentifierId === planningPartnerColumnIdentifier_1; });
                                        if (planningPartnerColumn) {
                                            return [2 /*return*/, {
                                                    field: planningPartnerColumn.name,
                                                    operator: '=',
                                                    value: searchCriteria.planningPartnerShortName
                                                }];
                                        }
                                        return [3 /*break*/, 16];
                                    case 7:
                                        houseColumnIdentifier_1 = this.columnIdentifiers.find(function (i) { return i.name === 'houseDistrictNumber'; }).id;
                                        houseColumn = columns.find(function (c) { return c.columnIdentifierId === houseColumnIdentifier_1; });
                                        if (houseColumn) {
                                            return [2 /*return*/, {
                                                    field: houseColumn.name,
                                                    operator: 'IN',
                                                    value: searchCriteria.houseDistrictNumber.toString()
                                                }];
                                        }
                                        return [3 /*break*/, 16];
                                    case 8:
                                        senateColumnIdentifier_1 = this.columnIdentifiers.find(function (i) { return i.name === 'senateDistrictNumber'; }).id;
                                        senateColumn = columns.find(function (c) { return c.columnIdentifierId === senateColumnIdentifier_1; });
                                        if (senateColumn) {
                                            return [2 /*return*/, {
                                                    field: senateColumn.name,
                                                    operator: 'IN',
                                                    value: searchCriteria.senateDistrictNumber.toString()
                                                }];
                                        }
                                        return [3 /*break*/, 16];
                                    case 9:
                                        congressColumnIdentifier_1 = this.columnIdentifiers.find(function (i) { return i.name === 'congressDistrictNumber'; }).id;
                                        congressColumn = columns.find(function (c) { return c.columnIdentifierId === congressColumnIdentifier_1; });
                                        if (congressColumn) {
                                            return [2 /*return*/, {
                                                    field: congressColumn.name,
                                                    operator: 'IN',
                                                    value: searchCriteria.congressionalDistrictNumber.toString()
                                                }];
                                        }
                                        return [3 /*break*/, 16];
                                    case 10: return [2 /*return*/, this.generateRouteFilterSubqueries(columns, searchCriteria)];
                                    case 11:
                                        countyQuery = tslib_1.__assign({}, searchCriteria.query.subqueries.filter(function (x) { return x.field === 'cty_code'; })[0]);
                                        countyQuery.name = this.aoiQueryName;
                                        return [2 /*return*/, countyQuery];
                                    case 12:
                                        districtIdentifier_1 = this.columnIdentifiers.find(function (i) { return i.name === 'districtNumber'; }).id;
                                        district = columns.find(function (c) { return c.columnIdentifierId === districtIdentifier_1; });
                                        ctyIdentifier_1 = this.columnIdentifiers.find(function (i) { return i.name === 'countyCode'; }).id;
                                        cty = columns.find(function (c) { return c.columnIdentifierId === ctyIdentifier_1; });
                                        if (district) {
                                            return [2 /*return*/, {
                                                    field: district.name,
                                                    operator: 'IN',
                                                    value: searchCriteria.districtNumbers.join(',')
                                                }];
                                        }
                                        if (!cty) return [3 /*break*/, 14];
                                        return [4 /*yield*/, Promise.all(searchCriteria.districtNumbers.map(function (d) { return _this.gisToolsService.getCountiesByDistricts([d]); }))];
                                    case 13:
                                        counties = _b.sent();
                                        return [2 /*return*/, {
                                                field: cty.name,
                                                operator: 'IN',
                                                value: counties.flat().map(function (c) { return c.countyCode; }).toString()
                                            }];
                                    case 14: return [3 /*break*/, 16];
                                    case 15: return [3 /*break*/, 16];
                                    case 16: return [2 /*return*/];
                                }
                            });
                        }); }))];
                    case 4:
                        subqueries = _a.sent();
                        return [2 /*return*/, subqueries.filter(function (q) { return q !== undefined; })];
                }
            });
        });
    };
    AoiService.prototype.generateMunicipalityFilterSubqueries = function (columns, searchCriteria) {
        var _this = this;
        var county = columns.find(function (c) { return c.columnIdentifierId === _this.columnIdentifiers.find(function (i) { return i.name === 'countyCode'; }).id; });
        var municipality = columns.find(function (c) { return c.columnIdentifierId === _this.columnIdentifiers.find(function (i) { return i.name === 'municipalityCode'; }).id; });
        var countyMunicipality = columns.find(function (c) { return c.columnIdentifierId === _this.columnIdentifiers.find(function (i) { return i.name === 'countyMunicipalityCode'; }).id; });
        if (county && municipality) {
            return {
                operator: 'AND',
                subqueries: [
                    { field: county.name, operator: '=', value: searchCriteria.countyCode },
                    { field: municipality.name, operator: 'INCLUDES', value: searchCriteria.municipalityCode }
                ]
            };
        }
        if (countyMunicipality) {
            return {
                operator: 'AND',
                subqueries: [
                    { field: countyMunicipality.name, operator: 'INCLUDES', value: "" + searchCriteria.countyCode + searchCriteria.municipalityCode }
                ]
            };
        }
    };
    AoiService.prototype.generateRouteFilterSubqueries = function (columns, searchCriteria) {
        var _this = this;
        var countyCode = columns.find(function (c) { return c.columnIdentifierId === _this.columnIdentifiers.find(function (i) { return i.name === 'countyCode'; }).id; });
        var routeNumber = columns.find(function (c) { return c.columnIdentifierId === _this.columnIdentifiers.find(function (i) { return i.name === 'routeNumber'; }).id; });
        var subqueries;
        if (countyCode && routeNumber) {
            subqueries = [
                { field: countyCode.name, operator: '=', value: searchCriteria.countyCode },
                { field: routeNumber.name, operator: '=', value: searchCriteria.stateRouteNumber }
            ];
        }
        if (subqueries) {
            return { operator: 'AND', subqueries: subqueries };
        }
    };
    AoiService.prototype.showBySearchCriterias = function (addAsAOI, zoomToLayer, filter, clear, isGlobalFilter) {
        if (addAsAOI === void 0) { addAsAOI = true; }
        if (zoomToLayer === void 0) { zoomToLayer = true; }
        if (filter === void 0) { filter = true; }
        if (clear === void 0) { clear = true; }
        if (isGlobalFilter === void 0) { isGlobalFilter = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var result, symbols, layerSetting, layers, aoiLayers, polygonLayers, _a, error_1;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _b.trys.push([0, 7, , 8]);
                        if (clear) {
                            this.layerService.removeAoiLayers();
                        }
                        return [4 /*yield*/, this.processSearchCriterias(addAsAOI)];
                    case 1:
                        result = _b.sent();
                        if (!result) return [3 /*break*/, 3];
                        symbols = void 0;
                        if (this.searchCriterias[0].type !== 'assetId' && this.searchCriterias[0].type !== 'route' && this.searchCriterias[0].type !== 'intersection') {
                            this.boundarySymbol.type = 'simple-fill';
                            if (this.boundarySymbol.outline) {
                                this.boundarySymbol.outline.type = 'simple-line';
                            }
                            symbols = [this.boundarySymbol];
                        }
                        else if (this.lineSymbol) {
                            symbols = [this.lineSymbol];
                        }
                        layerSetting = {
                            id: result.layerId,
                            name: result.title,
                            query: result.query,
                            isAOI: addAsAOI,
                            opacity: 1,
                            renderers: symbols,
                            identifyEnabled: true,
                            zoomToLayer: zoomToLayer,
                            generateNewLayer: true
                        };
                        if (this.searchCriterias[0].type === 'assetId') {
                            layerSetting.identifyEnabled = true;
                        }
                        return [4 /*yield*/, this.layerService.addMapcoreLayersToMap([layerSetting])];
                    case 2:
                        layers = _b.sent();
                        layers.forEach(function (l) { return _this.layerService.moveLayerToTheBottom(l); });
                        _b.label = 3;
                    case 3:
                        aoiLayers = this.layerService.getAoiLayers();
                        polygonLayers = aoiLayers.filter(function (x) { return x.mapcoreProps && x.mapcoreProps.geometryTypes.indexOf('polygon') >= 0; });
                        polygonLayers.forEach(function (l) { return _this.layerService.moveLayerToTheBottom(l); });
                        if (!filter) return [3 /*break*/, 5];
                        return [4 /*yield*/, this.filterLayers(null, isGlobalFilter)];
                    case 4:
                        _a = _b.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        _a = null;
                        _b.label = 6;
                    case 6: return [2 /*return*/, _a];
                    case 7:
                        error_1 = _b.sent();
                        this.LoggingService.Log(error_1, LogLevel.Error);
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    AoiService.prototype.showLayersFromQueryParameters = function (removeAoiLayers, zoomToLayer, color) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var mapcoreLayer, result, layerSetting, esriLayers, esriMapImageLayer, esriLayerRenderer, error_2;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 4, , 5]);
                        if (removeAoiLayers) {
                            this.layerService.removeAoiLayers();
                        }
                        return [4 /*yield*/, this.processSearchCriterias(true)];
                    case 1:
                        result = _a.sent();
                        if (!result) return [3 /*break*/, 3];
                        layerSetting = {
                            id: result.layerId,
                            name: result.title,
                            query: result.query,
                            isAOI: true,
                            zoomToLayer: zoomToLayer,
                            generateNewLayer: true,
                            visible: false // Initially hide to ensure default color isn't displayed
                        };
                        return [4 /*yield*/, this.layerService.addMapcoreLayersToMap([layerSetting])];
                    case 2:
                        esriLayers = _a.sent();
                        esriMapImageLayer = esriLayers[0];
                        mapcoreLayer = esriMapImageLayer.sublayers.toArray()[0];
                        esriLayerRenderer = mapcoreLayer.renderer;
                        esriLayerRenderer.symbol.color = color;
                        esriMapImageLayer.visible = true; // Now display with desired color
                        _a.label = 3;
                    case 3: return [3 /*break*/, 5];
                    case 4:
                        error_2 = _a.sent();
                        this.LoggingService.Log(error_2, LogLevel.Error);
                        return [3 /*break*/, 5];
                    case 5: return [2 /*return*/, mapcoreLayer];
                }
            });
        });
    };
    AoiService.prototype.generateFilterQuery = function (mapcoreProps) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var filterSubqueries, filterQuery;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.generateFilterSubqueries(mapcoreProps)];
                    case 1:
                        filterSubqueries = _a.sent();
                        filterQuery = this.getFilterQuery(filterSubqueries);
                        return [2 /*return*/, filterQuery];
                }
            });
        });
    };
    AoiService.prototype.getFilterQuery = function (filterSubqueries) {
        var filterQuery = {};
        if (filterSubqueries) {
            if (filterSubqueries.length > 1) {
                filterQuery = { operator: 'OR', subqueries: filterSubqueries };
            }
            else if (filterSubqueries.length === 1) {
                filterQuery = filterSubqueries[0];
            }
            filterQuery.name = this.aoiQueryName;
        }
        return filterQuery;
    };
    AoiService.prototype.filterLayers = function (specificLayers, isGlobalFilter) {
        if (isGlobalFilter === void 0) { isGlobalFilter = false; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var e_3, _a, filteredLayers, unfilteredLayers, layers, visibleLayers_1, aoiPolygonLayers, spatialQueries, _loop_1, this_1, spatialQueries_1, spatialQueries_1_1, spatialQuery;
            var _this = this;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        filteredLayers = [];
                        unfilteredLayers = [];
                        layers = this.getAllLayers(specificLayers);
                        return [4 /*yield*/, this.loadColumnIdentifiers()];
                    case 1:
                        _b.sent();
                        return [4 /*yield*/, Promise.all(layers.map(function (layer) { return tslib_1.__awaiter(_this, void 0, void 0, function () {
                                var aoiQuery;
                                return tslib_1.__generator(this, function (_a) {
                                    switch (_a.label) {
                                        case 0:
                                            if (!(layer.mapcoreProps && layer.mapcoreProps.parentId && !layer.mapcoreProps.isAOI && isQueryableMapCoreLayer(layer))) return [3 /*break*/, 10];
                                            return [4 /*yield*/, this.generateFilterSubqueries(layer.mapcoreProps)];
                                        case 1:
                                            aoiQuery = _a.sent();
                                            if (!aoiQuery) return [3 /*break*/, 9];
                                            if (!aoiQuery.length) return [3 /*break*/, 7];
                                            if (!(!this.searchCriterias.find(function (c) { return c.type === 'county'; }) && this.searchCriterias.find(function (c) { return c.type === 'district'; }))) return [3 /*break*/, 3];
                                            // Remove Disticts from existing query
                                            return [4 /*yield*/, this.removeConflictingQuery('district', layer, false)];
                                        case 2:
                                            // Remove Disticts from existing query
                                            _a.sent();
                                            return [3 /*break*/, 6];
                                        case 3:
                                            if (!(this.searchCriterias.find(function (c) { return c.type === 'county'; }) && !this.searchCriterias.find(function (c) { return c.type === 'district'; }))) return [3 /*break*/, 6];
                                            // Remove County from existing query
                                            return [4 /*yield*/, this.removeConflictingQuery('county', layer, false)];
                                        case 4:
                                            // Remove County from existing query
                                            _a.sent();
                                            if (!isGlobalFilter) return [3 /*break*/, 6];
                                            return [4 /*yield*/, this.removeConflictingQuery('district', layer, false)];
                                        case 5:
                                            _a.sent();
                                            _a.label = 6;
                                        case 6:
                                            this.addQueryToLayer(aoiQuery, layer, true);
                                            filteredLayers.push(layer);
                                            return [3 /*break*/, 8];
                                        case 7:
                                            unfilteredLayers.push(layer);
                                            _a.label = 8;
                                        case 8: return [3 /*break*/, 10];
                                        case 9:
                                            if (this.searchCriterias[0].type === 'state') {
                                                this.clearAOIFilter(layer);
                                                filteredLayers.push(layer);
                                            }
                                            _a.label = 10;
                                        case 10: return [2 /*return*/];
                                    }
                                });
                            }); }))];
                    case 2:
                        _b.sent();
                        if (!unfilteredLayers.length) return [3 /*break*/, 4];
                        visibleLayers_1 = [];
                        aoiPolygonLayers = this.layerService.getAoiLayers().filter(function (x) { return x.mapcoreProps && x.mapcoreProps.geometryTypes.indexOf('polygon') >= 0; });
                        if (!aoiPolygonLayers.length) return [3 /*break*/, 4];
                        unfilteredLayers.forEach(function (layer) {
                            if (layer.visible) {
                                layer.visible = false; // Prevent refresh until new AOI filter applied
                                visibleLayers_1.push(layer);
                            }
                            _this.clearAOIFilter(layer);
                        });
                        return [4 /*yield*/, this.spatialQueryService.spatialQueryLayers(true, unfilteredLayers, aoiPolygonLayers)];
                    case 3:
                        spatialQueries = _b.sent();
                        _loop_1 = function (spatialQuery) {
                            var layer = unfilteredLayers.filter(function (x) { return x.id === spatialQuery.id; })[0];
                            var aoiQuery = this_1.spatialQueryService.getGuidQuery(spatialQuery.guid, this_1.aoiQueryName);
                            this_1.addQueryToLayer([aoiQuery], layer);
                            filteredLayers.push(layer);
                        };
                        this_1 = this;
                        try {
                            for (spatialQueries_1 = tslib_1.__values(spatialQueries), spatialQueries_1_1 = spatialQueries_1.next(); !spatialQueries_1_1.done; spatialQueries_1_1 = spatialQueries_1.next()) {
                                spatialQuery = spatialQueries_1_1.value;
                                _loop_1(spatialQuery);
                            }
                        }
                        catch (e_3_1) { e_3 = { error: e_3_1 }; }
                        finally {
                            try {
                                if (spatialQueries_1_1 && !spatialQueries_1_1.done && (_a = spatialQueries_1.return)) _a.call(spatialQueries_1);
                            }
                            finally { if (e_3) throw e_3.error; }
                        }
                        visibleLayers_1.forEach(function (l) { return l.visible = true; }); // Filter applied, allow refresh
                        _b.label = 4;
                    case 4: return [2 /*return*/, filteredLayers];
                }
            });
        });
    };
    AoiService.prototype.clearAOIFilter = function (layer) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var query;
            return tslib_1.__generator(this, function (_a) {
                query = layer.mapcoreProps.query;
                query = this.toSqlStringService.removeClauses(query, { name: this.aoiQueryName });
                // Only sub query matching need to clear and keep the child table/Join table query when global filter is cleared for statewide.
                if (layer.mapcoreProps.query.childTableQuery && layer.mapcoreProps.query.childTableRecord) {
                    query.childTableQuery = layer.mapcoreProps.query.childTableQuery;
                    query.childTableRecord = layer.mapcoreProps.query.childTableRecord;
                }
                if (layer.mapcoreProps.query.joinTableQuery && layer.mapcoreProps.query.joinRecord) {
                    query.joinTableQuery = layer.mapcoreProps.query.joinTableQuery;
                    query.joinRecord = layer.mapcoreProps.query.joinRecord;
                }
                this.layerService.updateLayerFilter(layer, query);
                return [2 /*return*/];
            });
        });
    };
    AoiService.prototype.getAllLayers = function (specificLayers) {
        return Object.values(this.layerService.mapLayers).flat().filter(function (layer) { return (!specificLayers || !specificLayers.length) || (specificLayers.includes(layer.mapcoreProps.id) || specificLayers.includes(layer.mapcoreProps.parentId)); });
    };
    AoiService.prototype.addQueryToLayer = function (aoiQuery, layer, updateLayerTheme) {
        if (updateLayerTheme === void 0) { updateLayerTheme = true; }
        if (aoiQuery.length > 0) {
            var filterQuery = this.getFilterQuery(aoiQuery);
            var query = layer.mapcoreProps.query;
            query = this.toSqlStringService.removeClauses(query, { name: this.aoiQueryName });
            query = this.toSqlStringService.addFilter(query, filterQuery);
            this.layerService.updateLayerFilter(layer, query, updateLayerTheme);
            this.filterService.saveLayerUsage(layer.mapcoreProps.id ? layer.mapcoreProps.id : layer.mapcoreProps.parentId, query);
            return layer;
        }
    };
    AoiService.prototype.removeConflictingQuery = function (type, layer, updateLayerTheme) {
        if (updateLayerTheme === void 0) { updateLayerTheme = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a, columns, filterColumnToRemove, query;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(!layer.mapcoreProps.columns || layer.mapcoreProps.columns.length === 0)) return [3 /*break*/, 2];
                        _a = layer.mapcoreProps;
                        return [4 /*yield*/, this.gisToolsService.getColumns(layer.mapcoreProps.parentId, 'name, columnIdentifierId')];
                    case 1:
                        _a.columns = _b.sent();
                        _b.label = 2;
                    case 2:
                        columns = layer.mapcoreProps.columns;
                        switch (type) {
                            case 'county':
                                filterColumnToRemove = this.getCountyColumn(columns);
                                break;
                            case 'district':
                                filterColumnToRemove = this.getDistrictColumn(columns);
                                break;
                            default:
                                break;
                        }
                        if (filterColumnToRemove) {
                            query = layer.mapcoreProps.query;
                            query = this.toSqlStringService.removeClauses(query, { field: filterColumnToRemove.name });
                            if (layer.mapcoreProps.query.childTableQuery && layer.mapcoreProps.query.childTableRecord) {
                                query.childTableQuery = layer.mapcoreProps.query.childTableQuery;
                                query.childTableRecord = layer.mapcoreProps.query.childTableRecord;
                            }
                            if (layer.mapcoreProps.query.joinTableQuery && layer.mapcoreProps.query.joinRecord) {
                                query.joinTableQuery = layer.mapcoreProps.query.joinTableQuery;
                                query.joinRecord = layer.mapcoreProps.query.joinRecord;
                            }
                            this.layerService.updateLayerFilter(layer, query, updateLayerTheme);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AoiService.prototype.setSelectedMapId = function (mapId) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var response;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.mapService.getMaps([mapId])];
                    case 1:
                        response = _a.sent();
                        this.selectedMap = response[0];
                        return [2 /*return*/];
                }
            });
        });
    };
    AoiService.prototype.showBySearchCriteriasAndMap = function (addAsAOI) {
        if (addAsAOI === void 0) { addAsAOI = true; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.selectedMap) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.mapService.openMap(this.selectedMap)];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2: return [4 /*yield*/, this.showBySearchCriterias(addAsAOI)];
                    case 3: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    AoiService.prototype.turnOnLayerIds = function (layerIds) {
        this.layerService.turnOnLayerIds(layerIds);
    };
    AoiService.prototype.openStreetView = function (params) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var streetViewLocation, railCrossing;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        streetViewLocation = {
                            countyCode: null,
                            stateRouteNumber: null,
                            segmentNumber: null,
                            offset: 0
                        };
                        if (!(params.countyNumber && params.routeNumber && params.segmentNumber)) return [3 /*break*/, 1];
                        streetViewLocation.countyCode = params.countyNumber;
                        streetViewLocation.stateRouteNumber = params.routeNumber;
                        streetViewLocation.segmentNumber = params.segmentNumber;
                        return [3 /*break*/, 6];
                    case 1:
                        if (!(params.latitude && params.longitude)) return [3 /*break*/, 3];
                        return [4 /*yield*/, this.getLocationFromLatLng(params.latitude, params.longitude)];
                    case 2:
                        streetViewLocation = _a.sent();
                        return [3 /*break*/, 6];
                    case 3:
                        if (!params.crossingId) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.gisToolsService.getRailCrossing(params.crossingId, 'crossingNumber, rmsLatitude, rmsLongitude')];
                    case 4:
                        railCrossing = _a.sent();
                        if (!(railCrossing && railCrossing.rmsLatitude && railCrossing.rmsLongitude)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this.getLocationFromLatLng(railCrossing.rmsLatitude, railCrossing.rmsLongitude)];
                    case 5:
                        streetViewLocation = _a.sent();
                        _a.label = 6;
                    case 6:
                        if (streetViewLocation.countyCode !== null && streetViewLocation.stateRouteNumber !== null && streetViewLocation.segmentNumber !== null) {
                            this.openStreetViewEvent.emit(streetViewLocation);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AoiService.prototype.getLocationFromLatLng = function (latitude, longitude, buffer) {
        if (buffer === void 0) { buffer = 100; }
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var crs, location;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        crs = {
                            countyCode: null,
                            stateRouteNumber: null,
                            segmentNumber: null,
                            offset: 0
                        };
                        return [4 /*yield*/, this.gisToolsService.getOffsetForLatLong(latitude, longitude, buffer, 'countyCode, stateRouteNumber, segmentNumber, offset')];
                    case 1:
                        location = _a.sent();
                        if (location && location.length > 0) {
                            crs.countyCode = location[0].countyCode;
                            crs.stateRouteNumber = location[0].stateRouteNumber;
                            crs.segmentNumber = location[0].segmentNumber;
                            crs.offset = location[0].offset;
                        }
                        return [2 /*return*/, crs];
                }
            });
        });
    };
    AoiService.ngInjectableDef = i0.defineInjectable({ factory: function AoiService_Factory() { return new AoiService(i0.inject(i1.LayerService), i0.inject(i2.GeocodeService), i0.inject(i3.GisToolsService), i0.inject(i4.MapService), i0.inject(i5.SpatialQueryService), i0.inject(i6.FilterService), i0.inject("LoggingService"), i0.inject(i7.ToSqlStringService)); }, token: AoiService, providedIn: "root" });
    return AoiService;
}());
export { AoiService };
